/**
 * Dev-only: bypass Keycloak and use a static token for local development.
 * Set VITE_DEV_BYPASS_KEYCLOAK=true in .env.local to enable.
 *
 * Replace the token below with your production token to work with production API locally.
 * ⚠️ Never commit a real token. This file is tracked - use a placeholder when pushing.
 *
 * Production guard: import.meta.env.DEV is false in production builds, so bypass can never run in prod.
 */
export const DEV_BYPASS_KEYCLOAK = import.meta.env.DEV && import.meta.env.VITE_DEV_BYPASS_KEYCLOAK === 'true'

export const DEV_STATIC_TOKEN = import.meta.env.VITE_DEV_STATIC_TOKEN ?? ''

/** Decode JWT payload for tokenParsed (used by AbilityContext for adminId). */
export const decodeTokenPayload = (token: string): Record<string, unknown> | null => {
  try {
    const payload = token.split('.')[1]
    if (!payload) return null
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decoded) as Record<string, unknown>
  } catch {
    return null
  }
}
